const config = {
    datetimeFormat: 'yyyy-MM-dd HH:mm:ss',
    dateFormat: 'yyyy-MM-dd',
    timeFormat: 'HH:mm:ss',
    listLimit: 20
}

export default config
